import billInfoModule from './module';

const storeConfig = {
  namespaced: true
};
const APP_NAMESPACE = 'billingUtilsBillInfo';

const registerModule = (store) => {
  store.registerModule(APP_NAMESPACE, { ...billInfoModule, namespaced: storeConfig.namespaced});
}

export {
  APP_NAMESPACE,
  registerModule,
};
